import { FC } from 'react';

import Table from 'modules/_shared/Table';

import RecipientsTableHeader from './RecipientsTableHeader';
import RecipientsTableBody from './RecipientsTableBody';

type RecipientsTableProps = {
  isResumeTable?: boolean;
};

const RecipientsTable: FC<RecipientsTableProps> = ({ isResumeTable }) => {
  const tableContent = (
    <>
      <RecipientsTableHeader isResumeTable={isResumeTable} />
      <RecipientsTableBody isResumeTable={isResumeTable} />
    </>
  );

  return <Table content={tableContent} />;
};

export default RecipientsTable;
